/*
 * Yup validator requiring the user to make a selection.
 * Has a default error message that can be changed.
 */
import * as yup from 'yup'
// TODO Move the messages to this file
import { makeSelectionMessage } from '../strings/messages'

export const selectionRequired = (errorMessage = makeSelectionMessage) =>
  yup.string().required(errorMessage)

export const selectionRequiredMulti = (errorMessage = makeSelectionMessage) =>
  yup.array().required(errorMessage)
